{
    "NewuserWelcomereporting": "Welkom bij rapportage",
    "NewuserWelcometoreporting": "Welkom bij rapportage",
    "NewuserLetsbegin": "Laten we beginnen.",
    "NewuserStartTutorial": "Begin",
    "NewuserSkiptutorial": "Sla handleiding over",
    "NewuserAddmodifyreport": "Rapporten toevoegen\/wijzigen...",
    "NewuserReportfiltering": "Bereikfiltering",
    "NewuserAddingfields": "Velden toevoegen...",
    "NewuserReportquickchanges": "Snelle wijzigingen melden...",
    "NewuserFinish": "Af hebben",
    "NewuserNext": "Volgende",
    "NewuserPrevious": "Vorig",
    "NAME": "LanguageNewUserTutorial"
}